import React from "react";
import Node from "./node";

class GridRenderer extends React.PureComponent {
  render() {
    const { grid, handleMouseDown, handleMouseEnter, handleMouseUp } = this.props;
    return (
      <div className="grid" style={{ height: window.innerHeight - 150 }}>
        {grid.map((row, rowIndex) => (
          <div key={rowIndex} className="d-flex" style={{ height: 20 }}>
            {row.map((node, nodeIndex) => {
              const { row, col, type } = node;
              return (
                <Node
                  key={nodeIndex}
                  col={col}
                  type={type}
                  onMouseDown={() => handleMouseDown(row, col)}
                  onMouseEnter={() => handleMouseEnter(row, col)}
                  onMouseUp={handleMouseUp}
                  row={row}
                  ref={node.ref}
                />
              );
            })}
          </div>
        ))}
      </div>
    );
  }
}

export default GridRenderer;
